/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root"
import { Route as AppRouteImport } from "./routes/_app"
import { Route as AppIndexRouteImport } from "./routes/_app.index"
import { Route as LoginResetRouteImport } from "./routes/login.reset"
import { Route as AppCapabilitiesCapabilityIdRouteImport } from "./routes/_app.capabilities.$capabilityId"

const AppRoute = AppRouteImport.update({
  id: "/_app",
  getParentRoute: () => rootRouteImport,
} as any)
const AppIndexRoute = AppIndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => AppRoute,
} as any)
const LoginResetRoute = LoginResetRouteImport.update({
  id: "/login/reset",
  path: "/login/reset",
  getParentRoute: () => rootRouteImport,
} as any)
const AppCapabilitiesCapabilityIdRoute =
  AppCapabilitiesCapabilityIdRouteImport.update({
    id: "/capabilities/$capabilityId",
    path: "/capabilities/$capabilityId",
    getParentRoute: () => AppRoute,
  } as any)

export interface FileRoutesByFullPath {
  "/login/reset": typeof LoginResetRoute
  "/": typeof AppIndexRoute
  "/capabilities/$capabilityId": typeof AppCapabilitiesCapabilityIdRoute
}
export interface FileRoutesByTo {
  "/login/reset": typeof LoginResetRoute
  "/": typeof AppIndexRoute
  "/capabilities/$capabilityId": typeof AppCapabilitiesCapabilityIdRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  "/_app": typeof AppRouteWithChildren
  "/login/reset": typeof LoginResetRoute
  "/_app/": typeof AppIndexRoute
  "/_app/capabilities/$capabilityId": typeof AppCapabilitiesCapabilityIdRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: "/login/reset" | "/" | "/capabilities/$capabilityId"
  fileRoutesByTo: FileRoutesByTo
  to: "/login/reset" | "/" | "/capabilities/$capabilityId"
  id:
    | "__root__"
    | "/_app"
    | "/login/reset"
    | "/_app/"
    | "/_app/capabilities/$capabilityId"
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AppRoute: typeof AppRouteWithChildren
  LoginResetRoute: typeof LoginResetRoute
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/_app": {
      id: "/_app"
      path: ""
      fullPath: ""
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/": {
      id: "/_app/"
      path: "/"
      fullPath: "/"
      preLoaderRoute: typeof AppIndexRouteImport
      parentRoute: typeof AppRoute
    }
    "/login/reset": {
      id: "/login/reset"
      path: "/login/reset"
      fullPath: "/login/reset"
      preLoaderRoute: typeof LoginResetRouteImport
      parentRoute: typeof rootRouteImport
    }
    "/_app/capabilities/$capabilityId": {
      id: "/_app/capabilities/$capabilityId"
      path: "/capabilities/$capabilityId"
      fullPath: "/capabilities/$capabilityId"
      preLoaderRoute: typeof AppCapabilitiesCapabilityIdRouteImport
      parentRoute: typeof AppRoute
    }
  }
}

interface AppRouteChildren {
  AppIndexRoute: typeof AppIndexRoute
  AppCapabilitiesCapabilityIdRoute: typeof AppCapabilitiesCapabilityIdRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppIndexRoute: AppIndexRoute,
  AppCapabilitiesCapabilityIdRoute: AppCapabilitiesCapabilityIdRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  AppRoute: AppRouteWithChildren,
  LoginResetRoute: LoginResetRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
